import { useGetFreeWhetherToUse, useGetUserSubsInfo } from "../api";

export const getUserSubs = () => {
    const { data: userSubscriptionInfo } = useGetUserSubsInfo();
    const { data: freeWhetherToUseData } = useGetFreeWhetherToUse();

    const ExpiredFreeTrial = freeWhetherToUseData?.isExpierd; // 만료되었으면 true 안되었으면 false
    const productName = userSubscriptionInfo?.productName;
    const subsName = userSubscriptionInfo?.subsName;

    if (subsName === "프리미엄") {
        if (productName?.includes("VVIP")) {
            return "VVIP";
        }
        return "VIP";
    }

    if (subsName === "베이직") {
        return "BASIC";
    }

    if (subsName === "스탠다드") {
        return "STANDARD";
    }

    if (!ExpiredFreeTrial) {
        return "FREE_TRIAL";
    }

    return "NONE";
};
